import { Layout, LayoutProps } from '@melio/penny';
import { forwardRef } from '@melio/platform-utils';

import { Header } from './Headers';

export type InvoiceFormLayoutProps = {
  onClose?: VoidFunction;
  isDisabled?: boolean;
  isLoading?: boolean;
  footer?: NonNullable<LayoutProps['footer']>['content'];
  header?: NonNullable<LayoutProps['header']>['content'];
  backgroundColor?: LayoutProps['backgroundColor'];
  variant: LayoutProps['variant'];
};

export const InvoiceFormLayout = forwardRef<InvoiceFormLayoutProps>(
  ({ isLoading, isDisabled, onClose, footer, header: _header, ...props }, ref) => {
    const header = _header ?? (onClose && <Header onClose={onClose} isDisabled={isDisabled} />);
    return (
      <Layout
        isLoading={isLoading}
        footer={footer && { content: footer, isSticky: true }}
        header={header && { content: header, isSticky: true }}
        data-component={InvoiceFormLayout.displayName}
        {...props}
        ref={ref}
      />
    );
  }
);
InvoiceFormLayout.displayName = 'InvoiceFormLayout';
